export default {
    shuffleService: false
}